import { User } from '@retail/auth/types';
import { QueryOptions, useFetch, UseFetchOptions } from '@shared/fetch-utils';
import { useMgPrisConfig } from '@retail/app/stores/app-config';
import { useMemo } from 'react';
import { buildUrl } from '@shared/utils';
import { mpeApi } from '@retail/mgpris/config';
import { useSelectedAppTenantHeader } from '@retail/app/hooks';
import { useAuthContext } from '@retail/auth/data-access';
import { useAuth0 } from '@auth0/auth0-react';
import { handleFetchErrorWithTokenRefresh } from '@retail/utils';

export function useFetchMe(queryOptions: QueryOptions = {}) {
  const { mpe } = useMgPrisConfig();
  const { token } = useAuthContext();
  const { getAccessTokenSilently } = useAuth0();
  const appTenantHeader = useSelectedAppTenantHeader();

  const baseOptions: UseFetchOptions & QueryOptions = {
    method: 'GET',
    queryKey: ['me'],
    url: buildUrl({
      base: mpe.url,
      route: mpeApi.users.me.getFullLinkPath(),
    }),
    ...queryOptions,
  };

  return useFetch<User>({
    ...baseOptions,
    token,
    onRejected: handleFetchErrorWithTokenRefresh(getAccessTokenSilently, baseOptions),
    headers: {
      ...baseOptions.headers,
      ...appTenantHeader,
    },
  });
}

export const useIsSuperUser = () => {
  const { data: me } = useFetchMe({ refetchOnWindowFocus: false });

  return useMemo(() => {
    return !!me?.isSuperUser;
  }, [me]);
};
